import { render, staticRenderFns } from "./PDisplayContainerOrderCurrent.vue?vue&type=template&id=13fc8406"
import script from "./PDisplayContainerOrderCurrent.vue?vue&type=script&lang=js"
export * from "./PDisplayContainerOrderCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports